/**
 * The honeypot's bait (PLT-7950): a debug endpoint and token that look forgotten in the shipped
 * front end, so someone reading our HTML or bundle for weak spots finds them. Nothing of ours ever
 * calls the endpoint; every request to it is someone probing. The server side is
 * `upserve/modules/honeypot/`.
 *
 * The same strings are written into `src/ui/index.html`, which cannot import them, and `lure-spec.ts`
 * fails when the two disagree or when any other file mentions the path.
 *
 * Neither value guards anything: the endpoint answers every request with the same 401 whatever
 * token it carries, and records it.
 */
export const HONEYPOT_PATH = '/api/v1/internal/debug/eval';

/** Matches the endpoint and anything below it, which probers try next. */
export const HONEYPOT_PATH_PREFIX = '/api/v1/internal/debug/';

/** The "leaked" token. A request carrying it read the lure, rather than scanning blind. */
export const HONEYPOT_TOKEN = 'dbg_live_3f9c27e1a84b4d0c9e6b52a7f1d38c60';
